import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LoansFormFields } from "web_myplann/Portfolio/Forms/LoansForm/LoansFormFields";
import { useEditLoansForm } from "web_myplann/Portfolio/Forms/LoansForm/useEditLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditLoansFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
	showFixation: boolean;
};

export const EditLoansForm = ({
	portfolioId,
	portfolio,
	detailRoute,
	showFixation,
}: EditLoansFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditLoansForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<LoansFormFields
				control={form.control}
				productCategory={portfolio.productCategory}
				showFixation={showFixation}
				namePlaceholder={t(Resources.Portfolio.EditPortfolio.Placeholders.name)}
				contractNumberPlaceholder={t(
					Resources.Portfolio.EditPortfolio.Placeholders.contractNumber,
				)}
			/>
		</PortfolioFormShell>
	);
};
